import CompanyRoutes from "../../../apiRoutes/CompanyRoutes";
import { GET, POST, POST_JSON } from "../../ConsumeApiController";

export async function participant_create(economy_uuid,email)
{
    const response = await POST_JSON(CompanyRoutes.Cashless.Participants.Create,{
        economy_uuid,
        email
    });

    return response;
}

export async function participant_getAll(economy_uuid)
{
    const response = await GET(CompanyRoutes.Cashless.Participants.GetAll+economy_uuid);
    return response;
}